export default __webpack_public_path__ + "static/media/grafema_clivitalbio_16.d10f725b.jpg";